export function ScrollToUp() {

	window.scrollTo({
		top: 0,
		behavior: "smooth",
	});

}

export const Rupiah = (props) => {

	const reverse = props.toString().split("").reverse().join("");
	const ribuan = reverse.match(/\d{1,3}/g);
	const final = ribuan.join(".").split("").reverse().join("");

	return `Rp ${final}`;

};

export const ThousandSeparator = (props) => {

	const reverse = props.toString().split("").reverse().join("");
	const ribuan = reverse.match(/\d{1,3}/g);
	const final = ribuan.join(".").split("").reverse().join("");

	return `${final}`;

};
